import { useTranslation } from 'react-i18next'

import { formatUsd } from '#/shared/lib/format'

import type { CarrierRequestPrice } from '../model/types'

interface RequestPriceProps {
  price: CarrierRequestPrice
}

export function RequestPrice({ price }: RequestPriceProps) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-start gap-1">
      <span className="text-lg font-semibold text-gray-900">
        {formatUsd(price.amount, { showCents: false })}
      </span>
      {price.deltaFromCod !== undefined && price.deltaFromCod > 0 && (
        <span className="inline-flex h-5 items-center rounded-md bg-orange-100 px-2 text-xs text-orange-700">
          {t('carrierRequests.moreThanCod', {
            amount: formatUsd(price.deltaFromCod, { showCents: false }),
          })}
        </span>
      )}
      {price.pricePerMile !== undefined && (
        <span className="text-xs text-gray-500">
          {t('carrierRequests.pricePerMile', {
            value: formatUsd(price.pricePerMile, { showCents: true }),
          })}
        </span>
      )}
    </div>
  )
}
